export default class Api {
	constructor(token, clientID, onUnauthorized) {
		this.token = token;
		this.clientID = clientID;
		this.onUnauthorized = onUnauthorized;
		this.baseUrl = "";
	}

	getClientID() {
		return this.clientID;
	}

	getToken() {
		return this.token ? "Token " + this.token.token : undefined;
	}

	getBaseUrl() {
		var prefix = "http://client_id.localhost.com:8000/";
		if (window.location.href.includes("xwatts-staging.co")) {
			prefix = "https://client_id.api.xwatts-staging.co/";
		} else if (window.location.href.includes("xwatts.co")) {
			prefix = "https://client_id.api.xwatts.co/";
		}
		return prefix.replace("client_id", this.clientID);
	}

	Delete(url, onSuccess, onError) {
		fetch(url, {
			method: "DELETE",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
				Authorization: this.getToken(),
			},
		})
			.then((response) => {
				if (response.ok) {
					onSuccess();
				} else if (response.status === 401) {
					this.onUnauthorized();
				} else {
					onError();
				}
			})
			.catch(() => {
				onError();
			});
	}

	Get(url, onSuccess, onError) {
		fetch(url, {
			method: "GET",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
				Authorization: this.getToken(),
			},
		})
			.then((response) => {
				if (!response.ok) {
					if (response.status === 401) this.onUnauthorized();
					throw response;
				}
				return response.json();
			})
			.then((data) => {
				onSuccess(data);
			})
			.catch((err) => {
				onError();
			});
	}

	async Patch(url, data, onSuccess, onError) {
		let response 
		try {

			response = await fetch(url, {
				method: "PATCH",
				body: JSON.stringify(data),
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
					Authorization: this.getToken(),
				},
			})
		} catch(err) {
			onError({ "non_field_errors": "Unexpected problem when trying to update" });
			return
		}
		if (response.ok) {
            const data = await response.json();
            onSuccess(data);
        } else if (response.status === 400) {
            const data = await response.json();
            onError(data);
        } else if (response.status === 401) {
            this.onUnauthorized()
        } else {
            onError({ "non_field_errors": "Unexpected problem when trying to update" });
        }
	}
    

	async Post(url, data, onSuccess, onError) {
		let response
		try {
			response = await fetch(url, {
				method: "POST",
				body: JSON.stringify(data),
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
					Authorization: this.getToken(),
				},
			});
		} catch (err) {
			onError({'non_field_error': 'Unexpected problem when trying to create'});
			return
		}

		if (response.ok) {
            const data = await response.json();
            onSuccess(data);
        } else if (response.status === 400) {
            const data = await response.json();
            onError(data);
        } else if (response.status === 401) {
            this.onUnauthorized()
        } else {
            onError({ "non_field_errors": "Unexpected problem when trying to create" });
        }
	}

	async Put(url, data, onSuccess, onError) {
		let response
		try {
			response = await fetch(url, {
				method: "PUT",
				body: JSON.stringify(data),
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
					Authorization: this.getToken(),
				},
			})
		} catch(err) {
			onError({ "non_field_errors": "Unexpected problem when trying to update" });
		}
			
		if (response.ok) {
            const data = await response.json();
            onSuccess(data);
        } else if (response.status === 400) {
            const data = await response.json();
            onError(data);
        } else if (response.status === 401) {
            this.onUnauthorized()
        } else {
            onError({ "non_field_errors": "Unexpected problem when trying to create" });
        }
	}
}
